import { OCCUPANCY_KEY_PREFIX } from './constants';

export const getResourceCategoryTypeOccupancyKey = (resourceCategoryType: $TSFixMe) =>
    `${OCCUPANCY_KEY_PREFIX}${resourceCategoryType}`;
